<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Users</h2>
    <div class="button-group">
      <!-- <button mat-raised-button color="primary" (click)="toggleSearch()">
        <mat-icon>search</mat-icon>
        @if (isSearchVisible) { Close search } @else { Search }
      </button> -->
      @if (selectedUsers.length > 0) {
        <button mat-raised-button color="warn" (click)="onBulkDelete()">
          <mat-icon>delete</mat-icon>
          Delete {{ selectedUsers.length }} selected
        </button>
      }
      <button mat-raised-button color="primary" (click)="onCreateUser()">
        <mat-icon>add</mat-icon>
        Add User
      </button>
    </div>
  </div>
  <app-user-search-box
    [isSearchVisible]="isSearchVisible"
    (userSearchFilter)="onUserSearchFilterChange($event)">
  </app-user-search-box>
  <app-generic-list
    [items]="users"
    [columnDefinitions]="columnDefinitions"
    [pageSize]="pageSize"
    [pageSizeOptions]="[10, 25, 50, 100]"
    [totalItems]="totalItems"
    [serverSidePagination]="true"
    [sortActive]="'userName'"
    [sortDirection]="'asc'"
    [enableAuditLog]="isDeveloper"
    [enableEdit]="true"
    [enableDelete]="true"
    [enableSelection]="true"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)"
    (auditLogClick)="onViewAuditLog($event)"
    (editClick)="onEditClick($event)"
    (deleteClick)="onDeleteClick($event)"
    (selectionChange)="onSelectionChange($event)"
    (itemSave)="onItemSave($event)">
  </app-generic-list>
</div>
